var _defs, _style, _path, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocator(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 27",
    width: 20,
    height: 27,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vector (1)-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 14,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAOAQMAAADOsQSRAAAAAXNSR0IB2cksfwAAAANQTFRFHzbHPBwf8QAAAAxJREFUeJxjYCAWAAAAKgABYuF0QwAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #1f36c7 } \r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m10 0.8c2.6 0 5.1 1 7 2.9 1.9 1.8 2.9 4.3 2.9 6.9 0 8.3-8.5 15.8-9.9 15.8-1.4 0-9.9-7.5-9.9-15.8 0-2.6 1-5.1 2.9-6.9 1.8-1.9 4.4-2.9 7-2.9zm-3 6.6c-0.8 0.8-1.3 1.8-1.3 3 0 1.1 0.5 2.2 1.3 3 0.8 0.8 1.9 1.3 3 1.3 1.1 0 2.2-0.5 3-1.3 0.8-0.8 1.3-1.9 1.3-3 0-1.2-0.5-2.2-1.3-3-0.8-0.9-1.9-1.3-3-1.3-1.1 0-2.2 0.5-3 1.3z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Layer 1",
    href: "#img1",
    x: 4,
    y: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocator);
export default __webpack_public_path__ + "static/media/locator.97afac83b64d03edb130672ff42629a0.svg";
export { ForwardRef as ReactComponent };